// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j7b0","footer":"styles_footer__3Y1wx","passCodeTooltip":"styles_passCodeTooltip__V7TOk"};